import Button from "@mui/material/Button";
import React from "react";

const CustomButton = ({
  sx,
  children,
  variant = "contained",
  color,
  onClick,
  ...props
}) => {
  return (
    <Button
      variant={variant}
      color={color}
      onClick={onClick}
      {...props}
      sx={[sx, { borderRadius: "50px", textTransform: "none", px: 2, py: 1.5, ":hover": {bgcolor: "#222222"} }]}
    >
      {children}
    </Button>
  );
};

export default CustomButton;
